import { useState } from 'react';
import { createAppointmentCalendar, type CalendarAppointment } from '../appointmentCalendar';
import './AddToCalendarButton.css';

export function AddToCalendarButton({ appointment }: { appointment: CalendarAppointment }) {
  const [error, setError] = useState('');
  const download = () => {
    setError('');
    let url: string | undefined;
    let link: HTMLAnchorElement | undefined;
    try {
      const calendar = createAppointmentCalendar(appointment);
      url = URL.createObjectURL(new Blob([calendar], { type: 'text/calendar;charset=utf-8' }));
      link = document.createElement('a');
      link.href = url;
      link.download = 'Zahnarzttermin.ics';
      document.body.appendChild(link);
      link.click();
    } catch (cause) {
      setError(cause instanceof Error ? cause.message : 'Die Kalenderdatei konnte nicht heruntergeladen werden. Bitte versuchen Sie es erneut.');
    } finally {
      link?.remove();
      // Safari needs the URL to remain valid while its download starts.
      if (url) { const objectUrl = url; window.setTimeout(() => URL.revokeObjectURL(objectUrl), 60000); }
    }
  };
  return (
    <div className="appointment-calendar">
      <button type="button" className="appointment-calendar__button" onClick={download}>
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
          <path d="M8 3v4M16 3v4M3 10h18M14 17h6M17 14v6" />
          <path d="M10 21H5a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v5" />
        </svg>
        Zum Kalender hinzufügen
      </button>
      {error && <p className="appointment-calendar__error" role="alert">{error}</p>}
    </div>
  );
}
